// import React, { useState, useEffect } from 'react'
// import { Box, Typography } from '@mui/material'
// import { useTheme } from '@mui/material'
// import { useAuth0 } from '@auth0/auth0-react'
// import { Fetching } from '../../components/Fetching'
// import List from './List'

// export const Workers = () => {
//   const [authUser, setAuthUser] = useState<any | undefined>()
//   const { isLoading, user } = useAuth0()
//   const theme = useTheme()

//   useEffect(() => {
//     if (user) {
//       setAuthUser(user)
//     }
//   }, [user])

//   if (isLoading) {
//     return <Fetching />
//   }

//   return <>
//     <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
//       <Typography variant='h4' gutterBottom>Workers</Typography>
//       <Box sx={{
//         marginTop: 1,
//         height: 500,
//         width: '100%',
//         '& .super-app-theme--header .MuiDataGrid-columnHeaderTitle': {
//           color: theme.palette.grey[900],
//           fontWeight: 'fontWeightRegular',
//         },
//         '& .super-app-theme--header div': {
//           color: theme.palette.primary.dark,
//           fontWeight: 'fontWeightRegular',
//         },
//       }}>
//         {(authUser) ? <List user={authUser} /> : null}
//       </Box>
//     </Box>
//   </>
// }

import { useAuth0 } from '@auth0/auth0-react'
import styled from '@emotion/styled'
import {
  ChevronRight,
  Close,
  ExpandMoreOutlined,
  Flag,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@mui/icons-material'
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Input,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  SwitchProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  CalendarIcon,
  FilterIconDark,
  PlusIcon,
  SearchIconSM,
} from '../../assets/icons/icons'
import { Fetching } from '../../components/Fetching'
import { useFilterProjects, useGetProjectsAll } from '../projects/hooks'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useChangeStatusWorkers, useGetListItems, useGetWorkers, useMutateDeleteUser } from './hooks'
import { formattedDate } from '../../lib/time'
import dayjs, { Dayjs } from 'dayjs'
import moment from 'moment'
import SnackBarContext from '../../context/SnackBarContext'

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }: { theme: any }) => ({
  width: 38,
  height: 22,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor:
          theme.palette.mode === 'dark' ? '#2ECA45' : theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

const serialize = (obj: any) => {
  var str = []
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  return str.join('&')
}

export const Workers = () => {
  const navigate = useNavigate()
  const now = Date.now()
  const theme = useTheme()
  const { isLoading, user } = useAuth0()

  const [tempSearch, setTempSearch] = useState('')
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)

  const [strParam, setStrParam] = useState('')
  const { data: projects, isFetching: isFetchingProjects } = useFilterProjects(
    'projects',
    strParam
  )
  const [authUser, setAuthUser] = useState<any | undefined>()

  const [userRoles, setUserRoles] = useState<
    'vtadmin' | 'superintendent' | 'worker' | null
  >(null)

  const [bulkAction, setBulkAction] = useState<null | HTMLElement>(null)
  let [selectedTimesheets, setSelectedTimesheets] = useState({})
  let [filterParam, setFilterParam] = useState('')
  const [openLimit, setOpenLimit] = useState<null | HTMLElement>(null)

  const { data: allProjects } = useGetProjectsAll('projects')

  const { data: workers,refetch, isFetching: isFetchingWorkers } = useGetWorkers(
    'workers',
    strParam
  )

  const { mutate: mutateUpdate, isLoading: isLoadingStatus } =
    useChangeStatusWorkers('change-worker-status', {})
    const deleteItemMutation = useMutateDeleteUser('key-for-items');

  const [checkedItems, setCheckedItems] = useState<any>([])
  const [isOpenFilterModal, setIsOpenFilterModal] = useState(false)
  const [filterBtnLoading, setFilterBtnLoading] = useState(false)
  const [selectedProjects, setSelectedProjects] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [selectedHours, setSelectedHours] = useState('')
  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)

  const [filterBtnClicked, setFilterBtnClicked] = useState(false)
  const [open , setOpen]=useState<boolean>(false)
  const {toggleSnackbar}=useContext(SnackBarContext)
  useEffect(() => {
    const serializedParams = serialize({
      search: tempSearch,
      pageSize: limit,
      page,
      projectId: selectedProjects,
      status: selectedStatus?.toLowerCase(),
      hours: selectedHours,
      startDate: startDate
        ? startDate?.startOf('day')?.toDate().toISOString()
        : null,
      endDate: endDate ? endDate?.endOf('day')?.toDate().toISOString() : null,
    })
    setStrParam('?' + serializedParams)
  }, [limit, page, tempSearch])

  useEffect(() => {
    if (user) {
      setAuthUser(user)
      setUserRoles(user[`${process.env.REACT_APP_WEB_URL}/roles`])
    }
  }, [user])
  useEffect(()=>{
    refetch()
  },[])
  useEffect(() => {
    setPage(1)
  }, [tempSearch])
  if (isLoading) {
    return <Fetching />
  }

  const handlePageChange = (newPage: any) => {
    setPage(newPage)
  }
  // Check if there is any filter
  const hasFilter = () => {
    return (
      tempSearch != '' ||
      selectedProjects != '' ||
      selectedStatus != '' ||
      selectedHours != '' ||
      startDate != null ||
      endDate != null
    )
  }

  // Reset filters
  const resetFilters = () => {
    setTempSearch('')
    setSelectedProjects('')
    setSelectedStatus('')
    setSelectedHours('')
    setStartDate(null)
    setEndDate(null)
    setFilterBtnLoading(false)
    setFilterBtnClicked(false)
    setIsOpenFilterModal(false)

    setStrParam(
      '?' +
        serialize({
          search: '',
          pageSize: limit,
          page,
          projectId: '',
          status: '',
          hours: '',
          startDate: null,
          endDate: null,
        })
    )
  }

  // Handle Close Filter Modal
  const handleClose = () => {
    setIsOpenFilterModal(false)
  }

  // Handle Filter
  const handleFilter = () => {
    setFilterBtnClicked(true)
    setFilterBtnLoading(true)

    setStrParam(
      '?' +
        serialize({
          search: tempSearch,
          pageSize: limit,
          page,
          projectId: selectedProjects,
          status: selectedStatus?.toLowerCase(),
          hours: selectedHours,
          startDate: startDate
            ? startDate?.startOf('day')?.toDate().toISOString()
            : null,
          endDate: endDate
            ? endDate?.endOf('day')?.toDate().toISOString()
            : null,
        })
    )

    setFilterBtnLoading(false)
    setIsOpenFilterModal(false)
  }
  const handleDeleteWorker = async () => {
    const selectedIds = Object.keys(checkedItems).filter((id: any) => checkedItems[id]);

    await Promise.all(
      selectedIds.map(async (id) => {
        await deleteItemMutation.mutateAsync(id)
      })
    );
    await mutateUpdate({
      ids: selectedIds,
      action: 'delete',
    })
    toggleSnackbar(`Workers deleted successfully.`, "success")
    setCheckedItems([])  
  }
  
     const handleDialogConfirm = () => {
      handleDeleteWorker()
      setOpen(false)
      setBulkAction(null)
      setCheckedItems([])  
  }
    
  // Bulk Action
  const handleChangeStatus = async (name: string) => {
    const selectedIds = Object.keys(checkedItems).filter((id: any) => checkedItems[id]);

    if (name === 'Make Active') {
         mutateUpdate({
            ids: selectedIds,
            isActive: true,
            action: 'update',
        });
    } else if (name === "Make Inactive") {
         mutateUpdate({
            ids: selectedIds,
            isActive: false,
            action: 'update',
        });
    } 
    setBulkAction(null)
    setCheckedItems([])  
};

  // Handle Search
  const handleSearch = (e: any) => {
    if (e.key === 'Enter') {
      setStrParam(
        '?' +
          serialize({
            search: tempSearch,
            pageSize: limit,
            page,
            projectId: selectedProjects,
            status: selectedStatus?.toLowerCase(),
            hours: selectedHours,
            startDate: startDate
              ? startDate?.startOf('day')?.toDate().toISOString()
              : null,
            endDate: endDate
              ? endDate?.endOf('day')?.toDate().toISOString()
              : null,
          })
      )
    }
  }

  // Radio Options
  const radioLabels = ['All', 'Active', 'Inactive']

  // Hour Options
  const hourOptions = [
    {
      key: 'All',
      value: '',
    },
    {
      key: '0 - 10',
      value: '0 - 10',
    },
    {
      key: '10 - 20',
      value: '10 - 20',
    },
    {
      key: '20 - 30',
      value: '20 - 30',
    },

    {
      key: '40+',
      value: '40 - 9999999999',
    },
  ]
  const styleIcon = { color: '#5A525B', marginLeft: 'auto' }

  return (
    <>
      <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
        <Box
          marginBottom={3}
          alignItems={'center'}
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}>
          <Typography variant='h4'>Workers</Typography>

          <Button
            variant='contained'
            sx={{
              padding: theme.spacing(1.5, 4, 1.5, 4),
              borderRadius: '8px',
              textTransform: 'capitalize',
              fontSize: '13px',
              // backgroundColor: getParam() != filterParam ? theme.palette.primary.main : '#7C7A80',
              // '&:hover': {
              //   backgroundColor: getParam() != filterParam ? theme.palette.primary.main : '#7C7A80',
              // }
            }}
            onClick={() => navigate('/workers/enrollment')}>
            <PlusIcon /> <Box sx={{ width: 10 }} /> Create Worker
          </Button>
        </Box>

        {/* Main Table */}
        <Card
          sx={{
            padding: 1,
            boxShadow: 'none',
            border: '1px solid #EEEEEE',
            borderRadius: '10px',
          }}>
          <CardHeader
            sx={{
              marginBottom: 0,
              paddingBottom: 0,
              paddingTop: '10px !important',
            }}
            title={
              <>
                <Box
                  sx={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    display: 'flex',
                  }}>
                  <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    flexDirection={'row'}>
                    <Box
                      sx={{
                        border: '2px solid #D7D4DE',
                        padding: '0px 10px',
                        borderRadius: '10px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                      }}>
                      <SearchIconSM />
                      <TextField
                        id='standard-basic'
                        label=''
                        variant='standard'
                        placeholder='Search by worker name'
                        value={tempSearch}
                        onChange={(e: any) => setTempSearch(e.target.value)}
                        onKeyDown={(e: any) => handleSearch(e)}
                        sx={{
                          paddingLeft: 1,
                          border: 'none !important',
                          width: '30vw',
                          outline: 'none',
                          '& input': {
                            fontSize: '16px',
                          },
                          '& div::after, & div::before, div:hover:not(.Mui-disabled, .Mui-error):before':
                            {
                              borderBottom: '0px solid black',
                            },
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        position: 'relative',
                      }}>
                      <Button
                        variant='contained'
                        sx={{
                          backgroundColor: '#E5E3E9',
                          boxShadow: 'none',
                          padding: theme.spacing(0.8, 2, 0.8, 2),
                          borderRadius: '8px',
                          textTransform: 'capitalize',
                          width: '100%',
                          fontSize: '14px',
                          color: 'black',
                          fontWeight: '400',
                          marginLeft: 2,
                          '&:hover': {
                            backgroundColor: '#E5E3E9',
                            boxShadow: 'none',
                          },
                        }}
                        // onClick={() => {
                        //   setSearch(tempSearch);
                        // }}
                        onClick={() => {
                          setIsOpenFilterModal(true)
                        }}>
                        <FilterIconDark /> <Box sx={{ width: 10 }} /> Filter
                        {hasFilter() && (
                          <Box
                            sx={{
                              backgroundColor: '#F0845D',
                              width: '8px',
                              height: '8px',
                              position: 'absolute',
                              right: 7,
                              top: 7,
                              borderRadius: 99,
                            }}
                          />
                        )}
                      </Button>

                      {isOpenFilterModal && (
                        <Box
                          sx={{
                            backgroundColor: 'red',
                          }}>
                          <Box
                            sx={{
                              backgroundColor: 'rgba(0,0,0,0.1)',
                              width: '100vw',
                              height: '100vh',
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              zIndex: 79,
                            }}
                            onClick={() => {
                              setIsOpenFilterModal(false)
                              handleClose()
                            }}
                          />
                          <Box
                            sx={{
                              ...style,
                              zIndex: 79,
                              width: 470,
                              maxHeight: '95vh',
                              overflow: 'scroll',
                              '::-webkit-scrollbar': {
                                display: 'none',
                              },
                            }}>
                            <Box
                              display='flex'
                              alignItems={'center'}
                              justifyContent={'end'}>
                              <IconButton onClick={() => handleClose()}>
                                <Close
                                  sx={{
                                    fontSize: '28px',
                                  }}
                                />
                              </IconButton>
                            </Box>
                            <Grid
                              container
                              sx={{
                                width: '100%',
                              }}
                              spacing={2}>
                              <Grid item xs={12}>
                                <Typography
                                  fontSize={'14px'}
                                  color='#5A525B'
                                  paddingBottom={0.5}
                                  fontWeight='bold'>
                                  Project(s)
                                </Typography>
                                <FormControl
                                  sx={{
                                    width: '100%',
                                    fontSize: '13px',
                                    color: '#ACB9B5',
                                  }}>
                                  <Box
                                    sx={{
                                      backgroundColor: 'white',
                                      borderRadius: '8px',
                                      border: '1px solid #DBDBDB',
                                    }}
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'center'}>
                                    <Select
                                      id='demo-simple-select'
                                      value={selectedProjects}
                                      onChange={e => {
                                        setSelectedProjects(e.target.value)
                                      }}
                                      IconComponent={ExpandMoreOutlined}
                                      sx={{
                                        width: '100%',
                                        border: 'none',
                                        boxShadow: 'none',
                                        padding: theme.spacing(
                                          0.8,
                                          1.6,
                                          0.8,
                                          1.6
                                        ),
                                        '& .MuiSelect-select': {
                                          padding: theme.spacing(
                                            0.8,
                                            0,
                                            0.8,
                                            0
                                          ),
                                        },
                                        '&:hover, & fieldset, & fieldset:hover':
                                          {
                                            border: 'none',

                                            margin: 0,
                                            boxShadow: 'none',
                                          },
                                      }}
                                      displayEmpty>
                                      {/* <MenuItem value="" disabled>
                                          Select project(s)
                                      </MenuItem> */}
                                      {allProjects?.map(
                                        (item: any, index: number) => (
                                          <MenuItem value={item?.id}>
                                            {item?.projectName}
                                          </MenuItem>
                                        )
                                      )}
                                    </Select>
                                  </Box>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12}>
                                <Typography
                                  fontSize={'14px'}
                                  color='#5A525B'
                                  paddingBottom={0.5}
                                  fontWeight='bold'>
                                  Status
                                </Typography>
                                <FormControl>
                                  <RadioGroup
                                    row
                                    aria-labelledby='demo-row-radio-buttons-group-label'
                                    name='row-radio-buttons-group'
                                    sx={{
                                      '& .MuiSvgIcon-root': {
                                        fontSize: 20,
                                        color: '#F0845D',
                                      },
                                      '& .MuiTypography-root': {
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: '#5A525B',
                                      },
                                    }}>
                                    {radioLabels?.map(
                                      (label: any, i: number) => (
                                        <FormControlLabel
                                          key={i}
                                          value={label}
                                          checked={label === selectedStatus}
                                          onChange={(e: any) =>
                                            setSelectedStatus(e.target.value)
                                          }
                                          control={<Radio />}
                                          label={label}
                                        />
                                      )
                                    )}
                                  </RadioGroup>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12}>
                                <Typography
                                  fontSize={'14px'}
                                  color='#5A525B'
                                  paddingBottom={0.5}
                                  fontWeight='bold'>
                                  Total number of hours
                                </Typography>
                                <FormControl
                                  sx={{
                                    width: '100%',
                                    fontSize: '13px',
                                    color: '#ACB9B5',
                                  }}>
                                  <Box
                                    sx={{
                                      backgroundColor: 'white',
                                      borderRadius: '8px',
                                      border: '1px solid #DBDBDB',
                                    }}
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'center'}>
                                    <Select
                                      id='demo-simple-select'
                                      value={selectedHours}
                                      onChange={e => {
                                        setSelectedHours(e.target.value)
                                      }}
                                      IconComponent={ExpandMoreOutlined}
                                      sx={{
                                        width: '100%',
                                        border: 'none',
                                        boxShadow: 'none',
                                        padding: theme.spacing(
                                          0.8,
                                          1.6,
                                          0.8,
                                          1.6
                                        ),
                                        '& .MuiSelect-select': {
                                          padding: theme.spacing(
                                            0.8,
                                            0,
                                            0.8,
                                            0
                                          ),
                                        },
                                        '&:hover, & fieldset, & fieldset:hover':
                                          {
                                            border: 'none',

                                            margin: 0,
                                            boxShadow: 'none',
                                          },
                                      }}
                                      displayEmpty>
                                      {/* <MenuItem value="" disabled>
                                        Select project(s)
                                      </MenuItem> */}
                                      {hourOptions?.map(
                                        (item: any, index: number) => (
                                          <MenuItem value={item?.value}>
                                            {item?.key}
                                          </MenuItem>
                                        )
                                      )}
                                    </Select>
                                  </Box>
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <Typography
                                  fontSize={'14px'}
                                  color='#5A525B'
                                  paddingBottom={0.5}
                                  fontWeight='bold'>
                                  Booked date
                                </Typography>

                                <Box
                                  sx={{
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    border: '1px solid #DBDBDB',
                                    padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                                    zIndex: '88',
                                  }}
                                  display={'flex'}
                                  alignItems={'center'}
                                  justifyContent={'center'}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                      value={startDate}
                                      onChange={(e: any) => setStartDate(e)}
                                      inputFormat='MMM DD, YYYY'
                                      renderInput={(params: any) => {
                                        return (
                                          <TextField
                                            {...params}
                                            variant='standard'
                                            name='projectDueDate'
                                            label=''
                                            required
                                            placeholder='Select  date'
                                            InputProps={{
                                              ...params?.InputProps,
                                              endAdornment: null,

                                              startAdornment: (
                                                // @ts-ignore
                                                <IconButton
                                                  {...params?.InputProps}
                                                  onClick={event => {
                                                    // @ts-ignore
                                                    params?.InputProps?.endAdornment?.props?.children?.props?.onClick()
                                                  }}>
                                                  <CalendarIcon />
                                                </IconButton>
                                              ),
                                            }}
                                            sx={{
                                              width: '100%',

                                              '& .MuiInput-underline:before': {
                                                display: 'none',
                                              },
                                              '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                                {
                                                  display: 'none',
                                                },
                                              '& .MuiInput-underline:after': {
                                                display: 'none',
                                              },
                                              '& .MuiInputBase-input': {
                                                color: '#5F5C5F',
                                              },
                                            }}
                                          />
                                        )
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Box>
                              </Grid>

                              <Grid item xs={6}>
                                <Typography // Don't remove it
                                  fontSize={'14px'}
                                  color='#5A525B'
                                  paddingBottom={0.5}
                                  fontWeight='bold'
                                  visibility='hidden'>
                                  Date
                                </Typography>

                                <Box
                                  sx={{
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    border: '1px solid #DBDBDB',
                                    padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                                    zIndex: '88',
                                  }}
                                  display={'flex'}
                                  alignItems={'center'}
                                  justifyContent={'center'}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                      value={endDate}
                                      onChange={(e: any) => setEndDate(e)}
                                      inputFormat='MMM DD, YYYY'
                                      minDate={startDate}
                                      renderInput={(params: any) => {
                                        return (
                                          <TextField
                                            {...params}
                                            variant='standard'
                                            name='projectDueDate'
                                            label=''
                                            required
                                            placeholder='Select  date'
                                            InputProps={{
                                              ...params?.InputProps,
                                              endAdornment: null,

                                              startAdornment: (
                                                // @ts-ignore
                                                <IconButton
                                                  {...params?.InputProps}
                                                  onClick={event => {
                                                    // @ts-ignore
                                                    params?.InputProps?.endAdornment?.props?.children?.props?.onClick()
                                                  }}>
                                                  <CalendarIcon />
                                                </IconButton>
                                              ),
                                            }}
                                            sx={{
                                              width: '100%',

                                              '& .MuiInput-underline:before': {
                                                display: 'none',
                                              },
                                              '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                                {
                                                  display: 'none',
                                                },
                                              '& .MuiInput-underline:after': {
                                                display: 'none',
                                              },
                                              '& .MuiInputBase-input': {
                                                color: '#5F5C5F',
                                              },
                                            }}
                                          />
                                        )
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Box>
                              </Grid>

                              <Grid item xs={12}>
                                <Button
                                  variant='contained'
                                  sx={{
                                    borderRadius: '7px',
                                    color: '#FFF',
                                    background: '#F0845D',
                                    textTransform: 'none',
                                    py: 1.5,
                                    width: '100%',
                                    boxShadow: 'none',
                                    ':hover': {
                                      background: '#F0845D',
                                      boxShadow: 'none',
                                    },
                                  }}
                                  onClick={() => handleFilter()}
                                  disabled={!hasFilter()}>
                                  {filterBtnLoading ? (
                                    <CircularProgress
                                      sx={{
                                        color: 'white',
                                        width: 20,
                                        height: 20,
                                      }}
                                      size={22}
                                    />
                                  ) : (
                                    'Apply'
                                  )}
                                </Button>
                              </Grid>
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}>
                                  {hasFilter() && (
                                    <>
                                      <Typography
                                        sx={{
                                          fontSize: 14,
                                          color: '#5A525B',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() => resetFilters()}>
                                        Clear Filters
                                      </Typography>
                                    </>
                                  )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Box>

                  <Box>
                    <Button
                      id='basic-button-1'
                      aria-controls={
                        Boolean(bulkAction) ? 'basic-menu-2' : undefined
                      }
                      aria-haspopup='true'
                      aria-expanded={Boolean(bulkAction) ? 'true' : undefined}
                      onClick={(event: any) =>
                        setBulkAction(event.currentTarget)
                      }
                      sx={{
                        backgroundColor: '#EEEEEE',
                        border: '1px solid #DEE2E0',
                        color: 'black',
                        fontWeight: '400',
                        padding: '5px 15px',
                        borderRadius: '10px',
                        marginLeft: 1,
                        textTransform: 'capitalize',
                      }}
                      endIcon={
                        bulkAction ? (
                          <KeyboardArrowUp sx={styleIcon} />
                        ) : (
                          <KeyboardArrowDown sx={styleIcon} />
                        )
                      }
                      disabled={Object.values(checkedItems).every(value => !value)}>
                      Bulk Action
                    </Button>
                    <Menu
                      id='basic-menu-2'
                      anchorEl={bulkAction}
                      open={Boolean(bulkAction)}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button-1',
                      }}
                      onClose={()=>setBulkAction(null)} 
                      sx={{
                        boxShadow: 'none',
                        '& .MuiPaper-root': {
                          boxShadow:
                            '0px 5px 12px 0px #0000000A, 0px 22px 22px 0px #00000008, 0px 49px 30px 0px #00000005, 0px 88px 35px 0px #00000003, 0px 137px 38px 0px #00000000',
                          borderRadius: '10px',
                          border: '1px solid #F1EFF5',
                        },
                        '& ul': {
                          padding: '7px 0px',
                          // backgroundColor: "red",
                          boxShadow: 'none',
                        },
                        '& li:hover': {
                          backgroundColor: 'transparent',
                        },
                        '& li': {
                          margin: '5px 17px',
                          borderBottom: '1px solid #DEE2E0',
                          textAlign: 'left',
                          padding: '5px 0',
                          fontSize: 14,
                          color: '#5F5C5F',
                          fontWeight: 600,
                        },
                        '& li:last-child': {
                          border: 'none !important',
                        },
                        marginTop: 1,
                      }}>
                      {['Make Active', 'Make Inactive'].map(item => (
                        <MenuItem
                          sx={{ width: 120 }}
                          onClick={() => handleChangeStatus(item)}>
                          {item}
                        </MenuItem>
                      ))}
                      <MenuItem
                          onClick={() => {
                            setOpen(true)
                            setBulkAction(null);   }}
                          sx={{ "&:hover": { backgroundColor: "#f0f0f0", } }}
                        >
                          Remove
                        </MenuItem>

                    </Menu>
                   <Dialog
                       open={open}
                       onClose={()=>setOpen(false)}
                       aria-labelledby="alert-dialog-title"
                       aria-describedby="alert-dialog-description"
                       >
                       <DialogTitle id="alert-dialog-title">
                          {"Delete Confirmation"}
                        </DialogTitle>
                       <DialogContent>
                         <DialogContentText id="alert-dialog-description">
                           Are you sure you want to delete this worker?
                         </DialogContentText>
                       </DialogContent>
                       <DialogActions>
                           <Button onClick={()=> setOpen(false)}
                            sx={{"&:hover": {backgroundColor: "#f0f0f0",}}}>
                             Cancel
                           </Button>
                           <Button 
                             onClick={
                              handleDialogConfirm
                              }
                              autoFocus
                              sx={{"&:hover": {backgroundColor: "#f0f0f0",}}}          
                            >
                             Yes
                            </Button>
                       </DialogActions>
                     </Dialog>
                  </Box>
                </Box>

                {hasFilter() && filterBtnClicked && (
                  <Box>
                    {selectedProjects && (
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          px: 2,
                          py: 1,
                          borderRadius: '40px',
                          border: '1px solid #D7D4DE',
                          mt: 2,
                          mr: 1,
                          gap: 2,
                        }}>
                        <Typography
                          sx={{
                            color: '#5F5C5F',
                          }}>
                          {allProjects?.find(
                            (item: any) => item?.id === selectedProjects
                          )?.projectName +
                            ' ' +
                            'Project'}
                        </Typography>
                        <Close
                          sx={{
                            cursor: 'pointer',
                            fontSize: '20px',
                          }}
                          onClick={() => {
                            setSelectedProjects('')
                            setStrParam(
                              '?' +
                                serialize({
                                  search: tempSearch,
                                  pageSize: limit,
                                  page,
                                  projectId: '',
                                  status: selectedStatus?.toLowerCase(),
                                  hours: selectedHours,
                                  startDate: startDate
                                    ? startDate
                                        ?.startOf('day')
                                        ?.toDate()
                                        .toISOString()
                                    : null,
                                  endDate: endDate
                                    ? endDate
                                        ?.endOf('day')
                                        ?.toDate()
                                        .toISOString()
                                    : null,
                                })
                            )
                          }}
                        />
                      </Box>
                    )}
                    {selectedStatus && (
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          px: 2,
                          py: 1,
                          borderRadius: '40px',
                          border: '1px solid #D7D4DE',
                          mt: 2,
                          mr: 1,
                          gap: 2,
                        }}>
                        <Typography
                          sx={{
                            color: '#5F5C5F',
                          }}>
                          {selectedStatus} Workers
                        </Typography>
                        <Close
                          sx={{
                            cursor: 'pointer',
                            fontSize: '20px',
                          }}
                          onClick={() => {
                            setSelectedStatus('')
                            setStrParam(
                              '?' +
                                serialize({
                                  search: tempSearch,
                                  pageSize: limit,
                                  page,
                                  projectId: selectedProjects,
                                  status: 'All',
                                  hours: selectedHours,
                                  startDate: startDate
                                    ? startDate
                                        ?.startOf('day')
                                        ?.toDate()
                                        .toISOString()
                                    : null,
                                  endDate: endDate
                                    ? endDate
                                        ?.endOf('day')
                                        ?.toDate()
                                        .toISOString()
                                    : null,
                                })
                            )
                          }}
                        />
                      </Box>
                    )}
                    {selectedHours && (
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          px: 2,
                          py: 1,
                          borderRadius: '40px',
                          border: '1px solid #D7D4DE',
                          mt: 2,
                          mr: 1,
                          gap: 2,
                        }}>
                        <Typography
                          sx={{
                            color: '#5F5C5F',
                          }}>
                          More than {selectedHours?.replace('+', '')} hours
                        </Typography>
                        <Close
                          sx={{
                            cursor: 'pointer',
                            fontSize: '20px',
                          }}
                          onClick={() => {
                            setSelectedHours('')
                            setStrParam(
                              '?' +
                                serialize({
                                  search: tempSearch,
                                  pageSize: limit,
                                  page,
                                  projectId: selectedProjects,
                                  status: 'All',
                                  hours: '',
                                  startDate: startDate
                                    ? startDate
                                        ?.startOf('day')
                                        ?.toDate()
                                        .toISOString()
                                    : null,
                                  endDate: endDate
                                    ? endDate
                                        ?.endOf('day')
                                        ?.toDate()
                                        .toISOString()
                                    : null,
                                })
                            )
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              paddingBottom: '15px !important',
              paddingTop: 0,
              marginTop: 2,
            }}>
            <WorkersTable
              setPage={() => {}}
              setSelectedTimesheets={setSelectedTimesheets}
              param={`${filterParam}limit=${limit}&page=${page}`}
              projects={workers?.data}
              checkedItems={checkedItems}
              setCheckedItems={setCheckedItems}
            />
            <Box
              alignItems={'center'}
              display={'flex'}
              justifyContent={'space-between'}
              mt={2}>
              <Button
                id='basic-button-1'
                aria-controls={Boolean(openLimit) ? 'basic-menu-1' : undefined}
                aria-haspopup='true'
                aria-expanded={Boolean(openLimit) ? 'true' : undefined}
                onClick={(event: any) => setOpenLimit(event.currentTarget)}
                sx={{
                  border: '1px solid #DEE2E0',
                  color: 'black',
                  fontWeight: '400',
                  padding: '5px',
                  borderRadius: '10px',
                }}
                endIcon={
                  <ChevronRight
                    sx={{ transform: 'rotate(90deg)', color: '#5A525B' }}
                  />
                }>
                {limit}
              </Button>
              <Menu
                id='basic-menu-1'
                anchorEl={openLimit}
                open={Boolean(openLimit)}
                onClose={() => setOpenLimit(null)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button-1',
                }}
                sx={{
                  boxShadow: 'none',
                  '& .MuiPaper-root': {
                    boxShadow:
                      '0px 5px 12px 0px #0000000A, 0px 22px 22px 0px #00000008, 0px 49px 30px 0px #00000005, 0px 88px 35px 0px #00000003, 0px 137px 38px 0px #00000000',
                    borderRadius: '10px',
                    border: '1px solid #F1EFF5',
                  },
                  '& ul': {
                    padding: '7px 0px',
                    // backgroundColor: 'red',
                    boxShadow: 'none',
                  },
                  '& li:hover': {
                    backgroundColor: 'transparent',
                  },
                  '& li': {
                    margin: '5px 10px',
                    borderBottom: '1px solid #DEE2E0',
                    textAlign: 'left',
                    padding: '5px 0',
                    fontSize: 14,
                    color: '#5F5C5F',
                  },
                  '& li:last-child': {
                    border: 'none !important',
                  },
                  marginTop: 1,
                }}>
                {[10, 20, 30].map(item => (
                  <MenuItem
                    sx={{
                      width: 48,
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      setOpenLimit(null)
                      setLimit(item)
                      setPage(1)
                    }}>
                    {item}
                  </MenuItem>
                ))}
              </Menu>

              <Pagination
                count={workers?.totalPages || 1}
                page={page}
                onChange={(event, newPage) => handlePageChange(newPage)}
                color='primary'
              />
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={!tempSearch && isFetchingWorkers}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </>
  )
}

const WorkersTable = ({
  param,
  projects,
  setPage,
  setSelectedTimesheets,
  checkedItems,
  setCheckedItems,
}: {
  param: any
  setPage: any
  projects: any
  setSelectedTimesheets: any
  checkedItems: any
  setCheckedItems: any
}) => {
  const navigate = useNavigate()
  const theme = useTheme()

  useEffect(() => {
    setPage(1)
  }, [param, setPage])

  // Function to parse the time and sum it
  const sumTotalTimeWorked = (timecards: any) => {
    let totalMinutes = 0

    timecards?.forEach((card: any) => {
      const time = card?.formattedTimeDurations?.totalTimeWorked
      if (time) {
        // Ensure that time is not undefined
        const [hours, minutes] = time?.split(':').map(Number)
        totalMinutes += hours * 60 + minutes
      }
    })

    // Convert total minutes back to "hours:minutes"
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    // Format the time to always show two digits for minutes
    const formattedMinutes = minutes?.toString().padStart(2, '0')

    return `${hours}:${formattedMinutes}`
  }

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          marginTop: 2,
          boxShadow: 'none',
          minHeight: '55vh',
          overflowY: 'auto',
        }}>
        <Table
          sx={{
            minWidth: 650,
            boxShadow: 'none',
          }}
          aria-label='simple table'>
          <TableHead sx={{}}>
            <TableRow
              sx={{
                color: '#E8E0E8',
                '& th': {
                  backgroundColor: '#24212C',
                  padding: '7px',
                  color: 'white',
                  fontWeight: 400,
                  whiteSpace: 'nowrap',
                },
                '& th:first-child': {
                  // alignItems: 'center',
                  // display: 'flex',
                  borderRadius: '10px 0px 0px 10px',
                },
                '& th:last-child': {
                  borderRadius: '0px 10px 10px 0px',
                },
              }}>
              <TableCell>
                <Box
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Checkbox
                    checked={(projects || [])?.every(
                      (row: any) => checkedItems[row?._id] == true
                    )}
                    onChange={e => {
                      setSelectedTimesheets(
                        (projects || []).reduce((a: any, b: any) => {
                          a[b._id] = e.target.checked ? b : null
                          return a
                        }, {})
                      )
                      setCheckedItems(
                        (projects || []).reduce((a: any, b: any) => {
                          a[b._id] = e.target.checked
                          return a
                        }, {})
                      )
                    }}
                    sx={{ color: 'white', fill: 'white' }}
                  />
                  Worker NAME
                </Box>
              </TableCell>
              <TableCell>CURRENT PROJECT(S)</TableCell>
              <TableCell>DATE</TableCell>
              <TableCell>LAST CLOCKIN</TableCell>
              <TableCell>TOTAL</TableCell>
              <TableCell>STATUS</TableCell>
              <TableCell>TYPE</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '& td': {
                backgroundColor: 'white',
                color: '#5F5C5F',
                fontWeight: 400,
                whiteSpace: 'nowrap',
                padding: '15px 0px',
                fontSize: 14,
              },
              '& td:first-child': {
                borderRadius: '10px 0px 0px 10px',
              },
              '& td:last-child': {
                borderRadius: '0px 10px 10px 0px',
              },
            }}>
            {projects?.length === 0 ? (
              <Typography
                sx={{
                  color: '#7C7A80',
                  fontSize: '17px',
                  pl: '10px',
                  mt: 2,
                }}>
                No results found
              </Typography>
            ) : (
              (projects || [])
                // ?.filter((row: any) => !row?.isDeleted)
                ?.map((row: any, index: any) => (
                  <TableRow
                    key={row?._id}
                    // onClick={() => {
                    //   navigate(row.id);
                    // }}
                    sx={{
                      // cursor: "pointer",
                      '& td, & th': {
                        border: 0,
                        padding:"7px",
                        background: index % 2 == 0 ? "white" : "#F1EFF5",
                      },
                      '& *': {
                        color: '#5F5C5F',
                      },
                      '& svg, & svg path': {
                        color: !checkedItems[row?._id] ? '#5F5C5F' : '#F0845D',
                      },
                    }}>
                    <TableCell scope='row'>
                      <Box
                        style={{
                          flexDirection: 'row',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'left',
                        }}>
                        {checkedItems[row?._id] == true ? (
                          <Checkbox
                            checked={true}
                            onChange={e => {
                              setSelectedTimesheets((prev: any) => ({
                                ...prev,
                                [row?._id]: e.target.checked ? row : null,
                              }))
                              setCheckedItems((prev: any) => {
                                return {
                                  ...prev,
                                  [row?._id]: e.target.checked,
                                }
                              })
                            }}
                            sx={{ color: 'red !important', fill: 'white' }}
                          />
                        ) : (
                          <Checkbox
                            checked={false}
                            onChange={e => {
                              setSelectedTimesheets((prev: any) => ({
                                ...prev,
                                [row?._id]: e.target.checked ? row : null,
                              }))
                              setCheckedItems((prev: any) => {
                                return {
                                  ...prev,
                                  [row?._id]: e.target.checked,
                                }
                              })
                            }}
                            sx={{ color: 'red !important', fill: 'white' }}
                          />
                        )}
                        <Avatar
                          src={row?.idPhoto}
                          alt={row?.firstName}
                          sx={{ marginRight: 1, width: 35, height: 35 }}
                        />
                        <Box
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '15ch',
                          }}>
                          {row?.firstName} {row?.lastName}
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                    {row?.projectData && row.projectData.some((item: { projectDetails: { projectName: any } }) => item?.projectDetails?.projectName) ? (
                      <Tooltip
                        title={
                          <Typography sx={{ fontSize: '15px' }}>
                            {row?.projectData
                              ?.map(
                                (item: any) => item?.projectDetails?.projectName || ''
                              )
                              .join(', ') || '---'}
                          </Typography>
                        }
                        arrow>
                        {row?.projectData
                          ?.map((item: any) => {
                            const projectName =
                              item?.projectDetails?.projectName || ''
                            return projectName.length > 10
                              ? projectName.slice(0, 10) + '...'
                              : projectName
                          })
                          .join(', ') || '---'}
                      </Tooltip>
                    ) : (
                      <>{row?.projectData?.map((item: any) => item?.projectDetails?.projectName || '---').join(', ') || '---'}</>
                    )}

                    </TableCell>

                    <TableCell>
                      {moment(row?.createdAt).format("MMMM Do YYYY")?moment(row?.createdAt).format("MMMM Do YYYY"):"---"}
                    </TableCell>
                    <TableCell>
                      {row?.timecards && row?.timecards?.length > 0
                        ? moment(row?.timecards[0]?.formattedTimeDurations?.startTime).format(
                            "hh:mm A"
                          )
                        : "---"}
                    </TableCell>
                    <TableCell>
                      {row?.timecards
                        ? sumTotalTimeWorked(row?.timecards || [])
                        : '---'}
                    </TableCell>
                    <TableCell>
                      {row?.isActive === true ? (
                        <Flag
                          sx={{
                            '& *': {
                              color: 'green !important',
                            },
                          }}
                        />
                      ) : (
                        <Flag
                          sx={{
                            '& *': {
                              color: 'red !important',
                            },
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {row?.isActive === true ? 'Active' : 'Inactive'}
                    </TableCell>
                    <TableCell style={{}}>
                      <WorkerMenu worker={row} />
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

const WorkerMenu = ({ worker }: any) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <Box
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          display: 'flex',
          paddingLeft: 3,
          cursor: 'pointer',
        }}>
        <IconButton
          sx={{ width: 35, height: 35 }}
          onClick={(event: any) => {
            setAnchorEl(event.currentTarget)
          }}>
          <svg
            width='5'
            height='17'
            viewBox='0 0 5 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M2.16683 0.167969C1.59219 0.167969 1.04109 0.396242 0.634765 0.802571C0.228436 1.2089 0.000162532 1.76 0.000162507 2.33464C0.000162482 2.90927 0.228436 3.46037 0.634765 3.8667C1.04109 4.27303 1.59219 4.5013 2.16683 4.5013C2.74146 4.5013 3.29256 4.27303 3.69889 3.8667C4.10522 3.46037 4.3335 2.90927 4.3335 2.33464C4.3335 1.76 4.10522 1.2089 3.69889 0.802571C3.29256 0.396242 2.74147 0.167969 2.16683 0.167969Z'
              fill='#A5A2A5'
            />
            <path
              d='M2.16683 6C1.59219 6 1.04109 6.22827 0.634765 6.6346C0.228436 7.04093 0.000162532 7.59203 0.000162507 8.16667C0.000162482 8.7413 0.228436 9.2924 0.634765 9.69873C1.04109 10.1051 1.59219 10.3333 2.16683 10.3333C2.74146 10.3333 3.29256 10.1051 3.69889 9.69873C4.10522 9.2924 4.3335 8.7413 4.3335 8.16667C4.3335 7.59203 4.10522 7.04093 3.69889 6.6346C3.29256 6.22827 2.74147 6 2.16683 6Z'
              fill='#A5A2A5'
            />
            <path
              d='M2.16683 11.8359C1.59219 11.8359 1.04109 12.0642 0.634765 12.4705C0.228436 12.8769 0.000162532 13.428 0.000162507 14.0026C0.000162482 14.5772 0.228436 15.1283 0.634765 15.5347C1.04109 15.941 1.59219 16.1693 2.16683 16.1693C2.74146 16.1693 3.29256 15.941 3.69889 15.5347C4.10522 15.1283 4.3335 14.5772 4.3335 14.0026C4.3335 13.428 4.10522 12.8769 3.69889 12.4705C3.29256 12.0642 2.74147 11.8359 2.16683 11.8359Z'
              fill='#A5A2A5'
            />
          </svg>
        </IconButton>
      </Box>

      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}>
        <MenuItem
          onClick={() => {
            navigate(worker?._id)
            handleClose()
          }}>
          View
        </MenuItem>
      </Menu>
    </>
  )
}

const style = {
  position: 'absolute' as 'absolute',
  top: 60,
  right: 0,
  // top: "50%",
  // left: "50%",
  // transform: "translate(-50%, -50%)",
  bgcolor: 'background.paper',
  borderRadius: '7px',
  boxShadow: `
      0px 4px 10px 0px rgba(36, 33, 44, 0.05),
      0px 18px 18px 0px rgba(36, 33, 44, 0.04),
      0px 40px 24px 0px rgba(36, 33, 44, 0.03),
      0px 71px 29px 0px rgba(36, 33, 44, 0.03),
      0px 111px 31px 0px rgba(36, 33, 44, 0.00)
    `,
  pl: 3,
  pb: 3,

  overlay: {
    background: '#FFFF00',
  },
}
